module.exports = __webpack_public_path__ + "img/loading.a3ee6f32.gif";